import React, { useEffect, useState } from "react";
import { Button, Card, Col, ListGroup, Nav, ProgressBar, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";

import Avatar from "../components/Avatar";

import prod1 from "../assets/img/prod1.jpg";
import prod2 from "../assets/img/prod2.jpg";
import prod3 from "../assets/img/prod3.jpg";
import prod4 from "../assets/img/prod4.jpg";
import prod5 from "../assets/img/prod4.jpg";

import img1 from "../assets/img/img1.jpg";
import img12 from "../assets/img/img12.jpg";

export default function ProductManagement() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        {/* <div className="d-md-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="main-title mb-0">Welcome <span className="fw-bolder">!Faruk</span></h4>
          </div>
          <div className="d-flex gap-2 mt-3 mt-md-0">
           
            <Button variant="" className="btn-white d-flex align-items-center gap-2">
              <i className="ri-printer-line fs-18 lh-1"></i>
            </Button>
            <Button variant="primary" className="d-flex align-items-center gap-2">
              <i className="ri-bar-chart-2-line fs-18 lh-1"></i>Book Appointment<span className="d-none d-sm-inline"></span>
            </Button>
          </div>
        </div> */}

        <Row className="g-3">
          <Col xl="3">
            <Row className="g-3 ">
             
              <Row className="g-3">
              {[
                {
                  "imgtop": "https://Deda.themepixels.me/static/media/img20.465978313ebdd15a8f4f.jpg",
                  "title": "Dirt Bike Championship",
                  "date": "20th January, 2025",
                  "location": "Dawaki, Abuja, Nigeria | 900108",
                  "mutual": [img1, img12],
                  "mutualprimary": "Rhea",
                  "mutualcount": 5,
                  "gender":"Male"
                }
                // ,{
                //   "imgtop": img21,
                //   "title": "Reggae Music Showdown",
                //   "date": "Mar 30 - Mar 31",
                //   "location": "Cebu Business Park, Cebu City",
                //   "mutual": [img15, img14],
                //   "mutualprimary": "Ian",
                //   "mutualcount": 2
                // }
              ].map((event, index) => (
                <Col xl="e" key={index}>
                  <Card className="card-event">
                    <Link to="#"><img src={event?.imgtop} className="card-img-top avatar-img" alt="" /></Link>
                    <Card.Body>
                      <h6><Link to="">
                      <span className=" fname">Faruk</span>  <span className="lname ml-1">Adekunle</span></Link></h6>
                      <p className="mb-0">{event.date} | {event.gender} | Married</p>
                      <p className="text-secondary fs-sm">{event.location}</p>

                      <div className="mutual-badge mb-4">
                        <ul>
                          {event.mutual.map((img, ind) => (
                            <li key={ind}><Avatar img={img} /></li>
                          ))}
                        </ul>
                        <label>{event.mutualprimary} and {event.mutualcount} connections interested</label>
                      </div>

                  
                  <div className="d-flex mt-6 align-items-center justify-content-between fs-xs mb-1">
                  <label className="mg-b-0 fw-medium text-secondary">Important Details</label>
                  <Link href="">Show All</Link>
                </div>

                <ListGroup className="" variant="flush">
                  {[
                    {
                      "label": "Blood Group",
                      "value": "A +"
                    }, {
                      "label": "Genotype",
                      "value": "AA Genotype"
                    }, {
                      "label": "Linked Relatives",
                      "value": "12"
                    }
                  ].map((item, index) => (
                    <ListGroup.Item key={index} className="px-0 d-flex justify-content-between">
                      <span className="fw-medium">{item.label}</span>
                      <span className="ff-numerals">{item.value}</span>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
                    </Card.Body>
                    
                    <Card.Footer>
                      <Button variant="primary"><i className="ri-star-line"></i> Send A Message</Button>
                      <Button variant="" className="btn-white"><i className="ri-share-box-line"></i> Share</Button>
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
            </Row>
             
            </Row>
          </Col>
          <Col xl="9">
            <Card className="card-one">
          <Nav className="nav-line d-none d-lg-flex mb-4">
              <Nav.Link href="" className="active">Profile Overview</Nav.Link>
              <Nav.Link href="">Medical Records</Nav.Link>
              <Nav.Link href="">Lab Examination Results</Nav.Link>
              <Nav.Link href="">Vital History</Nav.Link>
              <Nav.Link href="">Immunization</Nav.Link>
              <Nav.Link href="">Payment & Billing</Nav.Link>
            </Nav>
             
              <Card.Header>
                <Card.Title as="h6">Medical Records</Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header>
              <Card.Body className="p-3">
                {[
                  {
                    "image": prod1,
                    "name": "iPhone 14 Pro Max Leather Case",
                    "text": "Leather Case with MagSafe",
                    "price": "$35.50",
                    "available": "560",
                    "sold": "40",
                    "sales": "$1,420.00"
                  }, {
                    "image": prod2,
                    "name": "Apple Watch Series 7 GPS",
                    "text": "Midnight Aluminum Sport Band",
                    "price": "$395.99",
                    "available": "350",
                    "sold": "150",
                    "sales": "$59,398.50"
                  }, {
                    "image": prod3,
                    "name": "Apple Wireless Black Airpods",
                    "text": "(3rd Generation) Wireless Earbuds",
                    "price": "$210.95",
                    "available": "250",
                    "sold": "100",
                    "sales": "$21,095.00"
                  }, {
                    "image": prod4,
                    "name": "Macbook Air M2 Chip",
                    "text": "16GB Ram 512GB SSD Storage",
                    "price": "$1,910.00",
                    "available": "100",
                    "sold": "50",
                    "sales": "$95,500.00"
                  },{
                    "image": prod1,
                    "name": "iPhone 14 Pro Max Leather Case",
                    "text": "Leather Case with MagSafe",
                    "price": "$35.50",
                    "available": "560",
                    "sold": "40",
                    "sales": "$1,420.00"
                  }, {
                    "image": prod2,
                    "name": "Apple Watch Series 7 GPS",
                    "text": "Midnight Aluminum Sport Band",
                    "price": "$395.99",
                    "available": "350",
                    "sold": "150",
                    "sales": "$59,398.50"
                  }, {
                    "image": prod3,
                    "name": "Apple Wireless Black Airpods",
                    "text": "(3rd Generation) Wireless Earbuds",
                    "price": "$210.95",
                    "available": "250",
                    "sold": "100",
                    "sales": "$21,095.00"
                  }, {
                    "image": prod4,
                    "name": "Macbook Air M2 Chip",
                    "text": "16GB Ram 512GB SSD Storage",
                    "price": "$1,910.00",
                    "available": "100",
                    "sold": "50",
                    "sales": "$95,500.00"
                  }
                ].map((item, index) => (
                  <div className="product-wrapper" key={index}>
                    <Table>
                      <tbody>
                        <tr>
                          <td>
                            <div className="product-thumb">
                              <img src={item.image} alt="" />
                            </div>
                          </td>
                          <td>
                            <h6 className="mb-1">
                              <Link to="">{item.name}</Link>
                            </h6>
                            <span className="fs-sm text-secondary">{item.text}</span>
                          </td>
                          <td>
                            <label className="d-block text-secondary fs-sm mb-1">Price</label>
                            <span className="d-block fw-medium text-dark ff-numerals">{item.price}</span>
                          </td>
                          <td>
                            <label className="d-block text-secondary fs-sm mb-1">Available</label>
                            <span className="d-block fw-medium text-dark ff-numerals">{item.available}</span>
                          </td>
                          <td>
                            <label className="d-block text-secondary fs-sm mb-1">Sold</label>
                            <span className="d-block fw-medium text-dark ff-numerals">{item.sold}</span>
                          </td>
                          <td>
                            <label className="d-block text-secondary fs-sm mb-1">Sales</label>
                            <span className="d-block fw-medium text-dark ff-numerals">{item.sales}</span>
                          </td>
                          <Nav className="nav-icon nav-icon-sm ms-auto">
                                                      <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                                                      <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                                                    </Nav>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>
          
     
       
    
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
